import React from "react";
import Config from "../../../../utils/config/config";
import Avatar from "../../../../components/common/Avatar";
import { BUTTON_COLOR } from "../../../../utils/ColorPicker";
import { CircularProgress } from "@mui/material";


const Bot = ({ bot, subscribeToBot, createConversation, style, open, installingBotId }) => {
	if (!bot) return;

	const isInstalling = installingBotId === bot.botId;

	const handleInstall = async () => {
		if (isInstalling) return;
		await subscribeToBot(bot.botId);
	};

	return (
		<div className="flex items-start p-3 list justify-between" style={style}>
			<div className="flex">
				<div>
					<Avatar
						imgSrc={`${Config?.contentURL ?? ""}${bot?.logoUrl ?? ""}`}
						size={32}
						height={32}
					/>
				</div>
				<div className="ml-3">
					<h5 onClick={() => open(bot)} className={`text-[#4A4A4A] text-[15px] flex cursor-pointer`}>{bot.botName ?? ""}</h5>
					<div className="my-0 text-[#666666]">
						<small>
							<span style={{ color: BUTTON_COLOR }}>Free</span> |{" "}
							{bot.developer ?? "FrontM"}
						</small>
					</div>
					<div className={`text-[12px] text-[#999999]`}>
						{bot.description ?? ""}
					</div>
				</div>
			</div>
			<div>
				{bot.subscribed ? (
					<div className="ml-3">
						{/* {localBot && localBot.version !== bot.version ? (
							<div
								className={`btn btn-sm btn-outline-info btn-install cursor-pointer`}
								onClick={() => {
									subscribeToBot(bot.botId, "update");
									setTimeout(() => setLocalBot(bot), 2000);
								}}
							>
								Update
							</div>
						) : ( */}
						<div
							className={`rounded-[6px] text-white font-bold text-[14px] px-[6px] py-[3px] cursor-pointer`}
							onClick={() => createConversation(bot)}
							style={{ backgroundColor: BUTTON_COLOR }}
						>
							Open
						</div>
						{/* )} */}
					</div>
				) : (
					<div className="ml-3">
						<div
							className={`btn btn-sm btn-outline-info btn-install cursor-pointer`}
							onClick={handleInstall}
							disabled={isInstalling}
							style={isInstalling ? { width: '50px', justifyContent: 'center', alignItems: 'center', display: 'flex', paddingBlock: '9px' } : {}}
						>
							{isInstalling ?
								<CircularProgress size={14} className="text-[#007bff] opacity-60 align-middle" />
								: (
									"Install"
								)}
						</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default Bot;
